<script setup lang="ts">
import { useTranslation } from 'i18next-vue'

interface Props {
  modelValue: string
  helperText?: string
}

interface Emits {
  (e: 'update:modelValue', value: string): void
}

defineProps<Props>()
const emit = defineEmits<Emits>()
const { t } = useTranslation()

const updateNote = (value: string) => {
  emit('update:modelValue', value)
}
</script>

<template>
  <van-cell-group class="group-container" inset style="padding: 10px">
    <p style="font-size: 16px; font-weight: bold; padding-bottom: 10px">
      {{ t('appointmentrequest.detail') }}
    </p>

    <template v-if="helperText">
      <p class="tw-text-sm tw-text-gray-500 tw-mx-2">
        {{ helperText }}
      </p>
      <van-divider></van-divider>
    </template>

    <van-field
      style="padding: 0px; padding-bottom: 10px"
      :model-value="modelValue"
      @update:model-value="updateNote"
      autoresize
      :placeholder="$t('appointmentrequest.detail_placeholder')"
    />
  </van-cell-group>
</template>

<style scoped>
.group-container {
  margin: 15px 0px;
  border: 2px solid #c8c9cc;
  border-radius: 20px;
}
</style>
